import { Grid, Link, Typography } from '@methanesat/ui-components';

import { useTranslate } from '../../../../hooks';
import { OGIM_DATA_SOURCE_URL } from '../../../../consts/data';
import { useGetOgiDatabaseInfoQuery } from '../../../../reducers';

export const InfrastructureModalFooter = () => {
    const t = useTranslate();

    const response = useGetOgiDatabaseInfoQuery();
    const version = response.data?.[0].ogi_description;

    return (
        <Grid container display="flex" flexDirection="column">
            <Grid size={{ xs: 12 }}>
                {version && (
                    <Grid size="auto">
                        <Typography variant="caption" fontStyle="italic">
                            {`${t('emissionsMapPage.mapModals.common.versionLabel', { version })}`}
                        </Typography>
                    </Grid>
                )}
                <Grid size={{ xs: 12 }}></Grid>
            </Grid>
            <Grid size={{ xs: 12 }} ellipsis>
                <Typography variant="caption" fontStyle="italic">
                    {`${t('emissionsMapPage.mapModals.common.source')}: `}
                </Typography>
                <Typography variant="caption" fontStyle="italic">
                    <Link
                        variant="caption"
                        fontStyle="italic"
                        underline="always"
                        href={OGIM_DATA_SOURCE_URL}
                        target="_blank"
                        data-testid="infra-modal-data-source-href"
                        whiteSpace="nowrap"
                    >
                        {OGIM_DATA_SOURCE_URL}
                    </Link>
                </Typography>
            </Grid>
        </Grid>
    );
};
